<template>
  <!--
    微信分享引导浮层（老钱风）
    - 仅提示用户通过右上角原生 ··· 面板分享，不修改/劫持原生分享，无任何诱导奖励
    - 点击遮罩任意位置关闭；非微信环境也可展示（复制链接等场景复用）
  -->
  <van-overlay
    :show="state.visible"
    z-index="99"
    class="share-guide-mask"
    @click="closeShareGuide"
  >
    <div class="share-guide" @click.stop>
      <div class="guide-top">
        <span class="dots">•••</span>
        <span class="arrow">
          <Icon icon="solar:arrow-right-down-outline" :size="30" />
        </span>
      </div>
      <p class="guide-text">点击右上角 <b>•••</b></p>
      <p class="guide-sub">分享给微信好友 / 群聊<br/>或发送到朋友圈</p>
      <van-button
        plain
        round
        class="guide-btn"
        @click="closeShareGuide"
      >我知道了</van-button>
    </div>
  </van-overlay>
</template>

<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { useShareGuide } from '@/composables/useShareGuide'

const { state, closeShareGuide } = useShareGuide()
</script>

<style lang="scss" scoped>
.share-guide-mask {
  // 遮罩自身仅承担点击关闭，内容走正常文档流
}
.share-guide {
  position: absolute;
  top: calc(env(safe-area-inset-top, 0px) + 12px);
  right: 16px;
  left: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  animation: share-guide-in 220ms ease;
}
.guide-top {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-right: 4px;
}
.dots {
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 3px;
  color: #f3e9d8;
  line-height: 1;
  // 模拟右上角菜单胶囊高亮
  background: rgba(255, 255, 255, 0.92);
  color: var(--color-text-primary, #2f2a24);
  border-radius: 16px;
  padding: 6px 14px;
}
.arrow {
  color: #f3e9d8;
  display: flex;
  transform: translateY(10px);
}
.guide-text {
  margin: 0;
  width: 100%;
  text-align: right;
  font-size: 17px;
  font-weight: 600;
  color: #f8f3e9;
  line-height: 1.4;
  b {
    font-size: 19px;
    margin: 0 2px;
  }
}
.guide-sub {
  margin: 0;
  width: 100%;
  text-align: right;
  font-size: 14px;
  line-height: 1.6;
  color: rgba(248, 243, 233, 0.82);
}
.guide-btn {
  margin-top: 14px;
  align-self: center;
  min-width: 168px;
  height: 42px;
  border-color: rgba(248, 243, 233, 0.7);
  color: #f8f3e9;
  font-size: 15px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: none;
}
@keyframes share-guide-in {
  from { opacity: 0; transform: translateY(-8px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>
